<template>
  <!-- eslint-disable max-len -->
  <router-link
    tag="div"
    :to="link"
    class="app"
    :class="{ app_store: isInStore }"
  >
    <div
      v-if="!isInStore"
      class="app__icon"
      :class="{
        app__icon_vertical: type === 'books',
        app__icon_filled: app.image,
      }"
      :style="`background-image: url(${app.image})`"
    ></div>
    <div class="app__desc">
      <span class="app__title">
        {{ app.name }} <span v-if="isInStore">({{ app.bundle_id }})</span>
        <span
          v-if="app.original_trackid && app.original_trackid !== '0'"
          class="app__badge"
          >{{ $t("TWEAKED") }}</span
        >
      </span>
      <div v-if="!isUpdatable" class="app__info">
        <span class="app__version" v-if="type !== 'books'"
          >v {{ app.version || app.bundle_version }}</span
        >
        <span v-if="isInStore" class="app__size">{{
          prettysize(app.size)
        }}</span>
        <span v-if="!isInStore" class="app__price"
          ><img class="app__price-icon" src="@/assets/icon-price.svg" />
          {{ $t(app.price.toUpperCase()) }}</span
        >
        <router-link
          v-if="!isInStore"
          class="app__category"
          :to="`/search/?type=${type}&genre=${app.genre_id}`"
        >{{
            app.genre_id &&
            genres[type][app.genre_id] &&
            $t(genres[type][app.genre_id].name.toUpperCase())
          }}</router-link
        >
      </div>
      <router-link
        v-if="!isRequestable && !isUpdatable && !isInStore && +app.artist_id"
        class="app__publisher"
        :to="`/search/?type=${type}&dev=${app.artist_id}`"
        >{{ app.pname }}</router-link
      >
      <p v-if="isRequestable" class="app__status">
        {{ $t([app.status.toUpperCase(), app.status]) }} {{ $t("SINCE") }}
        {{ formatDate(app.status_changed_at * 1000) }}
      </p>
      <span v-if="isUpdatable" class="app__update">
        v {{ app.version_old
        }}<img class="app__update-icon" src="@/assets/icon-arrow.svg" />v
        {{ app.version_new }}
      </span>
      <span v-if="isUpdatable && !app.updateable" class="app__update-warning">{{
        $t("NOT_UPDATEABLE")
      }}</span>
      <span
        v-if="isInStore"
        class="app__store-warning"
        :class="`app__store-warning_${compatibilityClass}`"
        v-html="compatibilityString"
      ></span>
    </div>
    <div
      v-if="isRequestable"
      class="app__request request"
      :class="{ request_active: app.am_i_requested }"
    >
      <div class="request__info" @click.prevent="$emit('request')">
        <span class="request__button">+1</span>
        <svg
          class="request__icon"
          version="1.1"
          viewBox="0 0 14 9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fill-rule="evenodd">
            <g
              class="request__icon-fill"
              transform="translate(-893 -259)"
              fill="#8D8D8D"
              fill-rule="nonzero"
            >
              <g transform="translate(825 248)">
                <g transform="translate(28)">
                  <g transform="translate(4 4)">
                    <g transform="translate(36 2)">
                      <path
                        d="m9.324 9.674c0.504 0 1.064 0.074666 1.68 0.224 0.68134 0.17733 1.2367 0.406 1.666 0.686 0.504 0.336 0.756 0.714 0.756 1.134v1.456h-3.5v-1.456c0-0.79334-0.38266-1.4653-1.148-2.016 0.13067-0.018667 0.31267-0.028 0.546-0.028zm-4.648 0c0.504 0 1.0593 0.074666 1.666 0.224 0.68134 0.17733 1.232 0.406 1.652 0.686 0.504 0.336 0.756 0.714 0.756 1.134v1.456h-8.176v-1.456c0-0.42 0.252-0.798 0.756-1.134 0.42934-0.28 0.98466-0.50867 1.666-0.686 0.616-0.14933 1.176-0.224 1.68-0.224zm0-1.148c-0.308 0-0.59733-0.079333-0.868-0.238s-0.48533-0.37333-0.644-0.644-0.238-0.56-0.238-0.868 0.079333-0.59733 0.238-0.868 0.37333-0.48533 0.644-0.644 0.56-0.238 0.868-0.238 0.595 0.079333 0.861 0.238 0.476 0.371 0.63 0.637 0.231 0.55767 0.231 0.875-0.076999 0.609-0.231 0.875-0.364 0.47833-0.63 0.637-0.553 0.238-0.861 0.238zm4.648 0c-0.308 0-0.59733-0.079333-0.868-0.238s-0.48533-0.37333-0.644-0.644-0.238-0.56-0.238-0.868 0.079333-0.59733 0.238-0.868 0.37333-0.48533 0.644-0.644 0.56-0.238 0.868-0.238 0.59733 0.079333 0.868 0.238c0.27067 0.15867 0.48533 0.37333 0.644 0.644s0.238 0.56 0.238 0.868-0.079332 0.59733-0.238 0.868-0.37333 0.48533-0.644 0.644c-0.27067 0.15867-0.56 0.238-0.868 0.238z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <span class="request__num">{{ app.requesters_amount }}</span>
      </div>
      <i18next
        tag="span"
        path="PLUS_1_IF_YOU_WANT_THIS"
        class="request__text"
        v-show="!app.am_i_requested"
      >
        <span class="request__plus">+1</span>
      </i18next>
    </div>
    <div v-if="isInStore" class="actions">
      <button
        @click="installIpa"
        class="actions__install"
        :class="{ actions__install_disabled: installingIpa }"
      >
        <img
          class="actions__install-icon"
          :src="require(`@/assets/themes/${BRAND_KEY}/images/icon-install-primary.svg`)"
        />
        {{ $t("INSTALL") }}
        <template v-if="installingIpa">
          <div class="actions__loader">
            <div class="actions__loader-dot"></div>
            <div class="actions__loader-dot"></div>
            <div class="actions__loader-dot"></div>
          </div>
          <div class="actions__tooltip">{{ $t("REQUESTING") }}...</div>
        </template>
      </button>
      <button @click.prevent="deleteIpa" class="actions__remove">
        {{ deletingIpa ? $t("APP_REMOVING") : $t("REMOVE") }}
      </button>
    </div>
  </router-link>
</template>

<script>
import prettysize from 'prettysize';
import installAppMixin from '@/mixins/installApp';

export default {
  mixins: [installAppMixin],
  props: ['isRequestable', 'isUpdatable', 'isInStore', 'app', 'type'],
  data() {
    return {
      deletingIpa: false,
      installingIpa: false,
    };
  },
  computed: {
    link() {
      if (this.isInStore) {
        return '';
      }
      return `/app/${(this.type || this.app.type)}/${(this.isRequestable || this.isUpdatable) ? this.app.trackid : this.app.id}`;
    },
    genres() {
      return this.$store.getters.genres;
    },
    compatibilityClass() {
      if (!this.isInStore) {
        return '';
      }
      const { result } = this.app.is_compatible;
      if (result === 'yes') {
        return 'success';
      }
      if (result === 'no') {
        return 'error';
      }
      return '';
    },
    compatibilityString() {
      if (!this.isInStore) {
        return '';
      }
      const { result, reason } = this.app.is_compatible;
      if (result === 'yes') {
        return `${this.$t('COMPATIBLE_WITH_DEVICE')}. ${reason}`;
      }
      if (result === 'no') {
        return `${this.$t('NOT_COMPATIBLE_WITH_DEVICE')}. ${reason}`;
      }
      return `${this.$t('COMPATIBILITY_UNKNOWN')}. ${reason}`;
    },
  },
  methods: {
    formatDate(timestamp) {
      return new Date(timestamp).toLocaleString();
    },
    deleteIpa() {
      if (!this.isInStore || this.deletingIpa) {
        return;
      }

      this.$confirm(this.$t('DELETE_APP_WARNING')).then(() => {
        this.deletingIpa = true;
        this.$api.deleteIpa(this.app.id).then(() => {
          this.$emit('update');
        });
      });
    },
    installIpa() {
      if (this.installingIpa) {
        return;
      }

      this.installingIpa = true;

      this.installApp(this.app.id, 'MyAppStore').finally(() => { this.installingIpa = false; });
    },
    prettysize,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.app {
  padding: 10px;
  display: flex;
  border: 1px solid transparent;
  cursor: pointer;

  &_store {
    cursor: default;
    padding: 0;
  }

  &_store &__info {
    margin-bottom: 10px;
  }

  @include notebook {
    padding: 0;
    border: none;

    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }

  &:not(&_store):hover {
    @include desktop-only {
      border: 1px solid var(--tertiary-accent);
      box-shadow: 0px 4px 10px 0 var(--shadow-color);
      border-radius: 8px;
    }
  }

  &__desc {
    display: flex;
    flex-direction: column;
  }

  &__icon {
    flex: 0 0 100px;
    height: 100px;
    border-radius: 12px;
    margin-right: 15px;
    background-size: cover;
    background-position: center;

    &:not(&_filled) {
      background-color: var(--stub-bg);
    }

    &:not(&_vertical) {
      border-radius: 22.5%;
      mask: url(../assets/ios-mask.svg) center/100% 100% no-repeat;
    }

    @media (max-width: 767px) {
      width: 50px;
      height: 50px;
      flex: 0 0 50px;
    }

    &_vertical {
      height: 150px;

      @media (max-width: 767px) {
        height: 75px;
      }
    }
  }

  &__title {
    color: var(--text-tertiary);
    margin-bottom: 6px;
    margin-top: 5px;
    display: block;
    line-height: 20px;
    word-break: break-word;
  }

  &__badge {
    font-size: 10px;
    padding: 4px 3px 3px 3px;
    color: #2b2b05;
    text-transform: uppercase;
    border-radius: 2px;
    background-color: var(--bg-warning);
    margin-left: 3px;
    position: relative;
    top: -1px;
  }

  &__info,
  &__category,
  &__publisher {
    color: var(--text-primary);
    font-weight: 400;
  }

  &__version,
  &__price {
    display: inline-block;
    margin-right: 30px;

    @media (max-width: 767px) {
      margin-right: 8px;
    }
  }

  &__category,
  &__publisher {
    text-decoration: underline dotted;
  }

  &__price-icon {
    position: relative;
    top: 1px;
    filter: var(--img-filter);
  }

  &__publisher {
    display: inline-block;
    margin-top: 12px;
  }

  &__status {
    margin-top: auto;
    color: #525d66;
    font-size: 12px;
    padding: 10px 0 3px;
    font-weight: 400;
  }

  &__request {
    margin-left: auto;

    @include notebook {
      padding-left: 5px;
    }
  }

  &__update {
    color: var(--text-primary);
    font-weight: 400;
    margin-bottom: 7px;

    &-icon {
      margin: 0 30px;
    }

    &-warning {
      color: var(--configure-error-text);
      background: var(--bg-error);
      border-radius: 2px;
      padding: 3px;
      font-weight: 400;
      margin-top: auto;
      font-size: 12px;
    }
  }

  &__store-warning {
    background: var(--bg-warning);
    border-radius: 2px;
    color: #424225;
    padding: 3px;
    font-weight: 400;
    margin-top: auto;

    &_success {
      background: var(--bg-success);
      color: #053305;
    }

    &_error {
      background: var(--bg-error);
      color: var(--text-primary);
    }
  }
}

.request {
  text-align: right;

  &_active &__button {
    color: #fff;
    background: #d75b5b;
    box-shadow: none;
  }

  &_active &__icon-fill {
    fill: #b06a6a;
  }

  &__info {
    padding: 4px;
    background: var(--request-button-bg);
    border-radius: 2px;
    display: inline-flex;
    align-items: center;

    @include notebook {
      margin-right: 5px;
    }
  }

  &__button {
    background: var(--bg);
    border: 1px solid rgba(215, 91, 91, 0.5);
    border-radius: 2px;
    padding: 2px 8px;
    font-size: 12px;
    color: var(--text-primary);
    @include transition;
  }

  &__icon {
    width: 14px;
    height: 9px;
    margin: 0 2px 0 4px;

    &-fill {
      @include transition;
    }
  }

  &__num {
    color: var(--text-primary);
    font-size: 12px;
  }

  &__text {
    display: flex;
    align-items: center;
    color: var(--text-primary);
    font-size: 12px;
    margin-top: 4px;

    @include notebook {
      display: none;
    }
  }

  &__plus {
    background: var(--request-plus-bg);
    border-radius: 1.25px;
    padding: 3px 5px;
    margin-right: 4px;
    font-size: 8px;
  }
}

.actions {
  margin-left: auto;
  text-align: center;

  &__install {
    position: relative;
    display: flex;
    align-items: center;
    background: var(--bg);
    border: 1px solid lighten($primary, 20%);
    border-radius: 2px;
    font-size: 14px;
    padding: 4px 10px;
    color: $primary;
    font-weight: 500;

    &-icon {
      margin-right: 3px;
    }

    &_disabled {
      pointer-events: none;
    }
  }

  &__remove {
    color: #fa6565;
    font-size: 14px;
    margin-top: 5px;
  }

  &__loader {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: var(--bg);
    align-items: center;
    justify-content: center;

    &-dot {
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      margin-right: 3px;
      background: var(--text-primary);
      animation: wave 1.3s linear infinite;

      &:nth-child(2) {
        animation-delay: -1.1s;
      }

      &:nth-child(3) {
        animation-delay: -0.9s;
      }
    }

    @keyframes wave {
      0%,
      60%,
      100% {
        transform: initial;
      }

      30% {
        transform: translateY(-4px);
      }
    }
  }

  &__tooltip {
    position: absolute;
    left: -1px;
    top: -25px;
    color: #ffffff;
    font-size: 12px;
    background: #4e4e4e;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    white-space: nowrap;
    font-weight: 400;
    padding: 3px 5px;

    &:before {
      content: "";
      display: block;
      position: absolute;
      border-style: solid;
      border-width: 5px 4.5px 0 4.5px;
      border-color: #4e4e4e transparent transparent transparent;
      bottom: -5px;
      left: 15px;
    }
  }
}
</style>
